"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenReaderProvider = exports.ScreenReaderContext = void 0;
var preact_1 = require("preact");
var styles = require("./sr-wrapper.scss");
exports.ScreenReaderContext = (0, preact_1.createContext)(function (textToRead, delay) { });
var ScreenReaderProvider = /** @class */ (function (_super) {
    __extends(ScreenReaderProvider, _super);
    function ScreenReaderProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            textToRead: ''
        };
        _this._setTextToRead = function (text, delay) {
            if (delay === void 0) { delay = 500; }
            setTimeout(function () {
                _this.setState({ textToRead: text });
            }, delay);
        };
        return _this;
    }
    ScreenReaderProvider.prototype.render = function () {
        return ((0, preact_1.h)(exports.ScreenReaderContext.Provider, { value: this._setTextToRead },
            this.props.children,
            (0, preact_1.h)("div", { style: styles.srWrapper, "aria-live": 'polite', "data-testid": "screenReaderWrapper" },
                (0, preact_1.h)("span", { id: 'sr-only', "aria-label": this.state.textToRead }, this.state.textToRead))));
    };
    return ScreenReaderProvider;
}(preact_1.Component));
exports.ScreenReaderProvider = ScreenReaderProvider;
//# sourceMappingURL=index.js.map